
import React from 'react';

const MenuPage: React.FC = () => {
  const antipasti = [
    {
      name: "Antipasto di Rosmarino",
      description: "prosciutto crudo, lonza, salame Milano, salicornia, coppiette, porchetta, formaggio stagionato, mozzarella di bufala, ricotta, mortadella, olive, salumi e pomodori secchi, fagiolini con cetrioli",
      price: "16,00€"
    },
    {
      name: "Prosciutto crudo",
      description: "",
      price: "6,00€"
    },
    {
      name: "Prosciutto crudo e mozzarella di Bufala",
      description: "",
      price: "10,00€"
    },
    {
      name: "Mozzarella di Bufala",
      description: "",
      price: "6,00€"
    },
    {
      name: "Bruschetta olio e sale",
      description: "",
      price: "1,50€"
    },
    {
      name: "Bruschetta pomodoro",
      description: "",
      price: "3,00€"
    },
    {
      name: "Bruschetta pomodoro e prosciutto",
      description: "",
      price: "3,50€"
    },
    {
      name: "Mix bruschetta (4 pz)",
      description: "",
      price: "5,00€"
    },
    {
      name: "Supplì (1 pz)",
      description: "",
      price: "1,50€"
    },
    {
      name: "Crocchette (2 pz)",
      description: "",
      price: "1,50€"
    },
    {
      name: "Fiori di zucca (4+4)",
      description: "",
      price: "2,50€"
    },
    {
      name: "Parmigiana",
      description: "",
      price: "2,00€"
    },
    {
      name: "Olive ascolane (6pz)",
      description: "",
      price: "3,50€"
    },
    {
      name: "Mozzarelline (6 pz)",
      description: "",
      price: "3,50€"
    },
    {
      name: "Fritto misto (4 pz)",
      description: "",
      price: "7,00€"
    }
  ];

  const primi = [
    {
      name: "Amatriciana",
      description: "",
      price: "8,00€"
    },
    {
      name: "Carbonara",
      description: "",
      price: "8,00€"
    },
    {
      name: "Carbonara con tonnarello",
      description: "",
      price: "12,00€"
    },
    {
      name: "Gricia",
      description: "",
      price: "8,00€"
    },
    {
      name: "Arrabbiata",
      description: "",
      price: "8,00€"
    },
    {
      name: "Fettuccine pomodoro e basilico",
      description: "",
      price: "10,00€"
    },
    {
      name: "Fettuccine ai porcini",
      description: "",
      price: "10,00€"
    },
    {
      name: "Pappardelle cinghiale bianco o rosso",
      description: "",
      price: "11,00€"
    },
    {
      name: "Tonnarello cacio e pepe",
      description: "",
      price: "11,00€"
    },
    {
      name: "Tonnarello al datterino giallo",
      description: "",
      price: "11,00€"
    },
    {
      name: "Tonnarello alici e fiori di zucca",
      description: "",
      price: "11,00€"
    },
    {
      name: "Gnocchi con speck, pesto di rucola e provola",
      description: "",
      price: "10,00€"
    }
  ];

  const secondi = [
    {
      name: "Bistecca di manzo",
      description: "",
      price: "18,00€"
    },
    {
      name: "Grigliata mista",
      description: "",
      price: "14,00€"
    },
    {
      name: "Braciola di maiale",
      description: "",
      price: "9,00€"
    },
    {
      name: "Salsiccia grigliata (2 pz)",
      description: "",
      price: "6,00€"
    },
    {
      name: "Arrosticini di pecora (5 pz)",
      description: "",
      price: "6,00€"
    },
    {
      name: "Tagliata con rucola e pomodorini misti, parmigiano (g)",
      description: "",
      price: "20,00€"
    },
    {
      name: "Tagliata con funghi porcini (g)",
      description: "",
      price: "20,00€"
    },
    {
      name: "Tagliata al rosmarino",
      description: "",
      price: "18,00€"
    },
    {
      name: "Petto di pollo grigliato (g)",
      description: "",
      price: "9,00€"
    },
    {
      name: "Cotolette di pollo (1-2)",
      description: "",
      price: "9,00€"
    }
  ];

  const contorni = [
    {
      name: "Cicoria",
      description: "",
      price: "5,00€"
    },
    {
      name: "Patate al forno",
      description: "",
      price: "5,00€"
    },
    {
      name: "Patate fritte (g)",
      description: "",
      price: "5,00€"
    },
    {
      name: "Verdure grigliate",
      description: "",
      price: "6,00€"
    },
    {
      name: "Insalata mista",
      description: "",
      price: "6,00€"
    }
  ];

  const pizzeBianche = [
    {
      name: "Boscaiola",
      description: "mozzarella, funghi champignon, salsiccia",
      price: "9,00€"
    },
    {
      name: "Ortolana",
      description: "mozzarella, zucchine, melanzane",
      price: "8,50€"
    },
    {
      name: "Zucchina e Speck",
      description: "mozzarella, zucchine, speck",
      price: "9,00€"
    },
    {
      name: "Parmigiana",
      description: "mozzarella, melanzane, pomodoro, parmigiano, basilico",
      price: "9,00€"
    },
    {
      name: "Totò",
      description: "mozzarella, friarielli, salsiccia",
      price: "9,00€"
    },
    {
      name: "Contadina",
      description: "mozzarella, cicoria, salsiccia",
      price: "9,00€"
    },
    {
      name: "Patatosa",
      description: "mozzarella, patate al forno, salsiccia",
      price: "9,00€"
    },
    {
      name: "Porcina",
      description: "mozzarella, funghi porcini, prosciutto",
      price: "10,00€"
    },
    {
      name: "Porcini doc",
      description: "mozzarella, funghi porcini, salsiccia, provola affumicata",
      price: "12,00€"
    },
    {
      name: "Fumé",
      description: "mozzarella, provola affumicata, speck",
      price: "9,00€"
    },
    {
      name: "Verace",
      description: "mozzarella, datterini rossi, provola affumicata, origano, basilico",
      price: "10,00€"
    },
    {
      name: "Crostino e Cotto",
      description: "mozzarella, prosciutto cotto",
      price: "8,00€"
    },
    {
      name: "Crostino e Crudo",
      description: "mozzarella, prosciutto crudo",
      price: "8,00€"
    },
    {
      name: "Gorgonzola",
      description: "mozzarella, gorgonzola, pomodorini",
      price: "9,00€"
    },
    {
      name: "Quattro formaggi",
      description: "mozzarella, provola affumicata, gorgonzola, parmigiano",
      price: "9,00€"
    },
    {
      name: "Cacio e Pepe",
      description: "mozzarella, pecorino, pomodoro, pepe nero",
      price: "8,00€"
    },
    {
      name: "Mimosa",
      description: "mozzarella, patate lesse, pecorino, prezzemolo",
      price: "8,50€"
    },
    {
      name: "R.D.P.",
      description: "rughetta, datterini rossi, parmigiano",
      price: "10,00€"
    },
    {
      name: "Fiori e Alici",
      description: "mozzarella, fiori di zucca, alici",
      price: "8,50€"
    }
  ];

  const pizzeRosse = [
    {
      name: "Margherita",
      description: "salsa pomodoro, mozzarella, basilico",
      price: "7,00€"
    },
    {
      name: "Marinara",
      description: "salsa pomodoro, aglio, origano",
      price: "5,00€"
    },
    {
      name: "Napoli",
      description: "salsa pomodoro, mozzarella, alici, origano",
      price: "8,00€"
    },
    {
      name: "Capricciosa",
      description: "salsa pomodoro, mozzarella, funghi, carciofi, olive nere, prosciutto cotto",
      price: "9,00€"
    },
    {
      name: "Quattro stagioni",
      description: "salsa pomodoro, mozzarella, funghi, carciofi, olive, prosciutto",
      price: "9,00€"
    },
    {
      name: "Diavola",
      description: "salsa pomodoro, mozzarella, salame piccante",
      price: "8,00€"
    },
    {
      name: "Funghi",
      description: "salsa pomodoro, mozzarella, funghi champignon",
      price: "8,00€"
    },
    {
      name: "Prosciutto",
      description: "salsa pomodoro, mozzarella, prosciutto cotto",
      price: "8,00€"
    },
    {
      name: "Norcia",
      description: "salsa pomodoro, mozzarella, salsiccia",
      price: "8,50€"
    },
    {
      name: "Norma",
      description: "salsa pomodoro, mozzarella, melanzane, provola affumicata, ricotta salata, basilico",
      price: "9,00€"
    },
    {
      name: "Bufalina",
      description: "salsa pomodoro, mozzarella di bufala campana",
      price: "10,00€"
    },
    {
      name: "Golosa",
      description: "salsa pomodoro, mozzarella, wurstel, patatine",
      price: "10,00€"
    },
    {
      name: "Margherita con tonno e cipolla",
      description: "salsa pomodoro, mozzarella, tonno, cipolla",
      price: "10,00€"
    }
  ];

  const pizzeGourmet = [
    {
      name: "Margherita Datterina",
      description: "salsa datterino giallo, mozzarella di bufala",
      price: "10,00€"
    },
    {
      name: "Datterina",
      description: "salsa datterino giallo, bufala, olio, datterini gialli, basilico",
      price: "12,00€"
    },
    {
      name: "Datterina Crudo",
      description: "salsa datterino giallo, olive, datterini gialli, aglio, prosciutto crudo",
      price: "11,00€"
    },
    {
      name: "Datterina Porcini",
      description: "mozzarella, gorgonzola, pecorino, vino di Amalfi",
      price: "10,00€"
    },
    {
      name: "Datterina Parmigiana",
      description: "parmigiana, gorgonzola, pecorino, vino di Amalfi",
      price: "10,00€"
    },
    {
      name: "Fiori di Zucca",
      description: "fiori di zucca, mozzarella, pecorino, vino di Amalfi",
      price: "12,00€"
    },
    {
      name: "Burratina",
      description: "burratina, datterini rossi, prezzemolo, parmigiano",
      price: "14,00€"
    },
    {
      name: "Salmone",
      description: "salmone, prezzemolo, parmigiano",
      price: "12,00€"
    },
    {
      name: "Bresaola",
      description: "mozzarella, ricotta, bresaola, parmigiano e rughetta",
      price: "12,00€"
    },
    {
      name: "Verdure doc",
      description: "mozzarella, datterini rossi, melanzane, zucchine, peperoni",
      price: "12,00€"
    }
  ];

  const dolci = [
    {
      name: "Tiramisù classico",
      description: "",
      price: "5,00€"
    },
    {
      name: "Panna cotta",
      description: "cioccolato, amarena, caramello, frutti di bosco, frutto della passione, pistacchio",
      price: "5,00€"
    },
    {
      name: "Crostata",
      description: "",
      price: "5,00€"
    },
    {
      name: "Dolce del giorno",
      description: "",
      price: "6,00€"
    }
  ];

  const focacceGourmet = [
    {
      name: "Focaccia Prosciutto e Fichi",
      description: "prosciutto crudo, fichi freschi, rucola, gorgonzola dolce",
      price: "12,00€"
    },
    {
      name: "Focaccia Salmone",
      description: "salmone affumicato, philadelphia, capperi, rucola",
      price: "14,00€"
    },
    {
      name: "Focaccia Bresaola",
      description: "bresaola, rucola, pomodorini, scaglie di parmigiano",
      price: "13,00€"
    },
    {
      name: "Focaccia Vegetariana Gourmet",
      description: "verdure grigliate, mozzarella di bufala, pesto di basilico",
      price: "11,00€"
    },
    {
      name: "Focaccia Tonno e Stracciatella",
      description: "tonno, stracciatella di burrata, pomodorini, olive taggiasche",
      price: "13,00€"
    },
    {
      name: "Focaccia Speck e Brie",
      description: "speck, brie, noci, miele, rucola",
      price: "12,00€"
    }
  ];

  const calzoni = [
    {
      name: "Calzone Classico",
      description: "pomodoro, mozzarella, prosciutto cotto, funghi",
      price: "9,00€"
    },
    {
      name: "Calzone Ricotta e Spinaci",
      description: "ricotta, spinaci, mozzarella, parmigiano",
      price: "8,50€"
    },
    {
      name: "Calzone Quattro Formaggi",
      description: "mozzarella, gorgonzola, parmigiano, provola affumicata",
      price: "10,00€"
    },
    {
      name: "Calzone Salsiccia e Friarielli",
      description: "salsiccia, friarielli, mozzarella, provola",
      price: "10,00€"
    },
    {
      name: "Calzone Nutella",
      description: "nutella, zucchero a velo",
      price: "6,00€"
    },
    {
      name: "Calzone Salame Piccante",
      description: "pomodoro, mozzarella, salame piccante, peperoncino",
      price: "9,50€"
    }
  ];

  const bevande = [
    {
      name: "Acqua naturale (0,5l)",
      description: "",
      price: "1,50€"
    },
    {
      name: "Acqua frizzante (0,5l)",
      description: "",
      price: "1,50€"
    },
    {
      name: "Coca Cola (0,33l)",
      description: "",
      price: "2,50€"
    },
    {
      name: "Coca Cola (1,5l)",
      description: "",
      price: "4,00€"
    },
    {
      name: "Fanta (0,33l)",
      description: "",
      price: "2,50€"
    },
    {
      name: "Sprite (0,33l)",
      description: "",
      price: "2,50€"
    },
    {
      name: "Thè al limone (0,33l)",
      description: "",
      price: "2,50€"
    },
    {
      name: "Thè alla pesca (0,33l)",
      description: "",
      price: "2,50€"
    },
    {
      name: "Birra alla spina (0,4l)",
      description: "",
      price: "3,50€"
    },
    {
      name: "Birra alla spina (1l)",
      description: "",
      price: "7,00€"
    },
    {
      name: "Birra in bottiglia (0,33l)",
      description: "",
      price: "3,00€"
    },
    {
      name: "Birra in bottiglia (0,66l)",
      description: "",
      price: "5,00€"
    },
    {
      name: "Vino della casa rosso (0,25l)",
      description: "",
      price: "3,00€"
    },
    {
      name: "Vino della casa rosso (0,5l)",
      description: "",
      price: "5,00€"
    },
    {
      name: "Vino della casa rosso (1l)",
      description: "",
      price: "8,00€"
    },
    {
      name: "Vino della casa bianco (0,25l)",
      description: "",
      price: "3,00€"
    },
    {
      name: "Vino della casa bianco (0,5l)",
      description: "",
      price: "5,00€"
    },
    {
      name: "Vino della casa bianco (1l)",
      description: "",
      price: "8,00€"
    },
    {
      name: "Caffè",
      description: "",
      price: "1,00€"
    },
    {
      name: "Caffè corretto",
      description: "",
      price: "1,50€"
    },
    {
      name: "Cappuccino",
      description: "",
      price: "1,50€"
    },
    {
      name: "Caffè d'orzo",
      description: "",
      price: "1,50€"
    },
    {
      name: "Thè/Camomilla",
      description: "",
      price: "1,50€"
    },
    {
      name: "Amaro",
      description: "",
      price: "3,00€"
    },
    {
      name: "Grappa",
      description: "",
      price: "3,00€"
    },
    {
      name: "Limoncello",
      description: "",
      price: "3,00€"
    }
  ];

  return (
    <div className="min-h-screen bg-[#F9F7EA]">
      {/* Google Fonts Import */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500&display=swap');
        `}
      </style>
      
      {/* Navigation */}
      <nav className="bg-[#3D5639] shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <div className="text-[#F2E6AF] text-4xl font-bold" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Rosmarino
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-[#F9F7EA] hover:text-[#F2E6AF] px-4 py-3 rounded-md text-base font-medium transition-colors tracking-wide">
                  Home
                </a>
                <a href="/menu" className="bg-[#51674C] text-[#F9F7EA] px-4 py-3 rounded-md text-base font-medium tracking-wide">
                  Menu
                </a>
                <a href="/about" className="text-[#F9F7EA] hover:text-[#F2E6AF] px-4 py-3 rounded-md text-base font-medium transition-colors tracking-wide">
                  Chi Siamo
                </a>
                <a href="/contact" className="text-[#F9F7EA] hover:text-[#F2E6AF] px-4 py-3 rounded-md text-base font-medium transition-colors tracking-wide">
                  Contatti
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-[#3D5639] via-[#51674C] to-[#3D5639] py-20">
        <div className="max-w-4xl mx-auto text-center px-4">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#F2E6AF]/20 rounded-full mb-6">
              <i className="ri-restaurant-line text-4xl text-[#F2E6AF]"></i>
            </div>
            <h1 className="text-6xl md:text-7xl font-bold text-[#F2E6AF] mb-6" style={{ fontFamily: 'Great Vibes, cursive' }}>
              La Nostra Carta
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-[#F2E6AF] to-[#F9F7EA] mx-auto mb-6"></div>
            <p className="text-xl md:text-2xl text-[#51674C] max-w-3xl mx-auto leading-relaxed">
              Scopri i sapori autentici della tradizione italiana con ingredienti freschi selezionati e ricette della nonna tramandate da generazioni
            </p>
          </div>
          
          {/* Decorative Elements */}
          <div className="flex justify-center items-center space-x-8 mt-8">
            <div className="hidden md:flex items-center space-x-2 bg-[#F2E6AF]/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-leaf-line text-[#F2E6AF]"></i>
              <span className="text-[#F9F7EA] text-sm font-medium">Ingredienti Freschi</span>
            </div>
            <div className="hidden md:flex items-center space-x-2 bg-[#F2E6AF]/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-fire-line text-[#F2E6AF]"></i>
              <span className="text-[#F9F7EA] text-sm font-medium">Forno a Legna</span>
            </div>
            <div className="hidden md:flex items-center space-x-2 bg-[#F2E6AF]/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-heart-line text-[#F2E6AF]"></i>
              <span className="text-[#F9F7EA] text-sm font-medium">Fatto con Amore</span>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Content */}
      <div className="max-w-6xl mx-auto py-16 px-4">
        <div className="grid md:grid-cols-2 gap-8">
          
          {/* Antipasti Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-goblet-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Antipasti
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Per iniziare il vostro viaggio culinario</p>
            </div>

            <div className="space-y-6">
              {antipasti.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Primi Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-bowl-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Primi Piatti
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Pasta fresca e risotti della tradizione</p>
            </div>

            <div className="space-y-6">
              {primi.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Secondi Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-knife-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Secondi Piatti
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Carni alla griglia e specialità</p>
            </div>

            <div className="space-y-6">
              {secondi.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Contorni Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30 relative overflow-hidden">
            {/* Artistic Image - Bottom Left */}
            <div className="absolute bottom-4 left-4 w-24 h-24 opacity-10 transform rotate-12 z-0">
              <img 
                src="https://static.readdy.ai/image/8db0a309f4e529fd4405705b10cd8ce9/a65396e658f167cc3211cd35d59d2bd9.png"
                alt="Decorative food element"
                className="w-full h-full object-contain filter sepia-[0.3] brightness-110"
              />
            </div>
            
            <div className="text-center mb-10 relative z-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-plant-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Contorni
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Verdure fresche di stagione</p>
            </div>

            <div className="space-y-6 relative z-10">
              {contorni.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Pizze Rosse Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-restaurant-2-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Pizze Rosse
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Cotte nel nostro forno a legna</p>
            </div>

            <div className="space-y-6">
              {pizzeRosse.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Pizze Bianche Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-cake-3-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Pizze Bianche
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Senza pomodoro, ricche di sapore</p>
            </div>

            <div className="space-y-6">
              {pizzeBianche.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Pizze Gourmet Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-star-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Pizze Gourmet
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Le nostre creazioni speciali</p>
            </div>

            <div className="space-y-6">
              {pizzeGourmet.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Focacce Gourmet Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-bread-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Focacce Gourmet
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Focacce speciali con ingredienti ricercati</p>
            </div>

            <div className="space-y-6">
              {focacceGourmet.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Calzoni Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-pie-chart-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Calzoni
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Pizza chiusa ripiena di bontà</p>
            </div>

            <div className="space-y-6">
              {calzoni.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Dolci Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-cake-2-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Dolci
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Il dolce finale perfetto</p>
            </div>

            <div className="space-y-6">
              {dolci.map((item, index) => (
                <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Bevande Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#F2E6AF]/30 md:col-span-2">
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full mb-4">
                <i className="ri-cup-line text-2xl text-[#F2E6AF]"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Bevande
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#3D5639] to-[#F2E6AF] mx-auto mb-2"></div>
              <p className="text-[#51674C] text-sm italic">Vini selezionati e bevande fresche</p>
            </div>

            <div className="grid md:grid-cols-2 gap-x-8">
              <div className="space-y-6">
                {bevande.slice(0, Math.ceil(bevande.length / 2)).map((item, index) => (
                  <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                        {item.name}
                      </h3>
                      <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                        {item.price}
                      </span>
                    </div>
                    {item.description && (
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {item.description}
                      </p>
                    )}
                  </div>
                ))}
              </div>
              <div className="space-y-6">
                {bevande.slice(Math.ceil(bevande.length / 2)).map((item, index) => (
                  <div key={index} className="border-b border-[#F2E6AF] pb-4 last:border-b-0">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-lg font-medium text-[#3D5639] italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                        {item.name}
                      </h3>
                      <span className="text-lg font-bold text-[#51674C] ml-4 whitespace-nowrap">
                        {item.price}
                      </span>
                    </div>
                    {item.description && (
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {item.description}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Element */}
        <div className="text-center mt-16">
          <div className="inline-block">
            <i className="ri-leaf-line text-4xl text-[#51674C]"></i>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16 bg-gradient-to-r from-[#F9F7EA] to-[#F2E6AF] rounded-2xl p-12 shadow-lg">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#3D5639] rounded-full mb-6">
            <i className="ri-phone-line text-3xl text-[#F2E6AF]"></i>
          </div>
          <h3 className="text-3xl font-bold text-[#3D5639] mb-4" style={{ fontFamily: 'Great Vibes, cursive' }}>
            Prenota il Tuo Tavolo
          </h3>
          <p className="text-[#51674C] mb-8 text-lg max-w-2xl mx-auto">
            Vieni a gustare i nostri piatti in un'atmosfera accogliente e familiare. 
            La tradizione italiana ti aspetta nelle nostre due sedi.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/393480846132?text=Ciao! Vorrei prenotare un tavolo presso il Ristorante Rosmarino. Potreste aiutarmi con la prenotazione?"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-[#25D366] text-white px-8 py-4 rounded-lg hover:bg-[#128C7E] transition-colors font-medium whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill mr-2 text-xl"></i>
              Prenota su WhatsApp
            </a>
            <button className="bg-[#3D5639] text-[#F2E6AF] px-8 py-4 rounded-lg hover:bg-[#51674C] transition-colors font-medium whitespace-nowrap">
              <i className="ri-phone-fill mr-2"></i>
              Chiama Ora
            </button>
          </div>
        </div>

      </div>

      {/* Footer */}
      <footer className="bg-[#3D5639] text-[#F9F7EA] py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="mb-4">
                <div className="text-[#F2E6AF] text-xl font-bold" style={{ fontFamily: 'Great Vibes, cursive' }}>
                  Rosmarino
                </div>
              </div>
              <p className="text-sm leading-relaxed">
                Ristorante tradizionale italiano con due sedi nel Lazio. Sapori autentici e atmosfera familiare dal 1985.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-[#F2E6AF]">Le Nostre Sedi</h4>
              <div className="space-y-4 text-sm">
                <div>
                  <p className="font-medium text-[#F2E6AF]">Ariccia</p>
                  <p><i className="ri-map-pin-line mr-2"></i>Viale Antonietta Chigi 16, 00072 Ariccia (RM)</p>
                  <p><i className="ri-phone-line mr-2"></i>06 45769762</p>
                  <p><i className="ri-time-line mr-2"></i>Chiuso Lunedì | Mar-Dom: 11:00-00:00</p>
                </div>
                <div>
                  <p className="font-medium text-[#F2E6AF]">Ciampino</p>
                  <p><i className="ri-map-pin-line mr-2"></i>Piazza Trento e Trieste 3, 00043 Ciampino (RM)</p>
                  <p><i className="ri-phone-line mr-2"></i>06 45763624</p>
                  <p><i className="ri-time-line mr-2"></i>Chiuso Lunedì | Mar-Gio: 15:30-00:00 | Ven-Dom: 11:00-00:00</p>
                </div>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-[#F2E6AF]">Orari</h4>
              <div className="space-y-2 text-sm">
                <p>Lun-Gio: 12:00 - 15:00</p>
                <p>Lun-Gio: 19:00 - 23:00</p>
                <p>Ven-Dom: 12:00 - 23:00</p>
              </div>
            </div>
          </div>
          <div className="border-t border-[#51674C] mt-8 pt-8 text-center text-sm">
            <p>&copy; 2024 Rosmarino. Tutti i diritti riservati. | <a href="https://readdy.ai/?origin=logo" className="text-[#F2E6AF] hover:underline">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MenuPage;
